export const RS_NULL_DASH = '―';
